import { shellRead } from './shellRead';   // Round 4e: one shell request, after paint

// Shared cache for the HEAVY /payments/attention endpoint (computeAged × N). One fetch, short TTL,
// reused by LeftMenu + ModuleBar so the Payments "overdue orders" badge (fb-71) shows in both the
// left menu and the top-nav dropdown without double-firing the query. peekAttention() returns the
// last value synchronously (for an initial render); getAttentionCached() refreshes past the TTL.
let _c = null, _at = 0;
const TTL = 60000;

export function peekAttention() { return _c; }

export async function getAttentionCached() {
  if (_c && Date.now() - _at < TTL) return _c;
  const a = await shellRead('attention');
  _c = a; _at = Date.now();
  return a;
}
